import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const navConfig = [
  {
    title: 'Home',
    path: '/',
    icon: icon('ic_home'),
  },
  {
    title: 'ข้อมูลพนักงาน',
    path: null,
    icon: icon('ic_dataEmployee'),
  },
  {
    title: 'ฝึกอบรม',
    path: null,
    icon: icon('ic_orientation'),
  },
  {
    title: 'ประเมิน',
    path: null,
    icon: icon('ic_evalution'),
  },
  {
    title: 'สมัครงาน',
    path: null,
    icon: icon('ic_recruit'),
  },

  {
    title: 'รายงาน',
    path: null,
    icon: icon('ic_allReport'),
  },
  {
    title: 'สวัสดิการ',
    path: null,
    icon: icon('ic_reward2'),
  },
  {
    title: 'อื่นๆ',
    path: null,
    icon: icon('ic_docOther'),
  },
   {
    title: 'การจัดการ',
    path: null,
    icon: icon('ic_manageDept'),
  },
  {
    title: 'ลาออก',
    path: null,
    icon: icon('ic_resign'),
  },
  // {
  //   title: 'แดชบอร์ด',
  //   path: '/',
  //   icon: icon('ic_analytics'),
  // },
  // {
  //   title: 'จัดการพนักงาน',
  //   path: '/user',
  //   icon: icon('ic_user'),
  //   disabled:true
  // },
  // {
  //   title: 'จัดการสินทรัพย์',
  //   path: '/user',
  //   icon: icon('ic_manageAssets'),
  //   disabled:true
  // },

  // {
  //   title: 'รายการคำร้องขอกำลังพล',
  //   path: '/approveReqList',
  //   icon: icon('ic_listReqEmployee'),
  //   // disabled:true
  // },
  // {
  //   title: 'ร้องขอกำลังพล',
  //   path: '/reqEmployee',
  //   icon: icon('ic_recruitment'),
  //   // disabled:true
  // },
  // {
  //   title: 'รายการคำร้องขอสมัครงาน',
  //   path: '/listRecruit',
  //   icon: icon('ic_listRecruit'),
  //   // disabled:true
  // },
  // {
  //   title: 'ประเมินผู้สมัครงาน',
  //   path: '/candidateEvaluation',
  //   icon: icon('ic_candidateEvaluation'),
  //   // disabled:true
  // },
  // {
  //   title: 'ประกาศ/ระเบียบ/เอกสารฯ',
  //   path: '/docOther',
  //   icon: icon('ic_docOther'),
  //   // disabled:true
  // },
  {
    title: 'งานที่สมัคร',
    path: '/listSignup',
    icon: icon('ic_listRecruit'),
    // disabled:true
  },
  {
    title: 'ตำแหน่งที่เปิดรับสมัคร',
    path: '/deptOnOpen',
    icon: icon('ic_deptOnOpen'),
    // disabled:true
  },
  {
    title: 'งานที่สนใจ',
    path: '/favoriteJob',
    icon: icon('ic_heart'),
    // disabled:true
  },
  // {
  //   title: 'ประเมินทดลองงาน',
  //   path: '/probationEva',
  //   icon: icon('ic_probationEva'),
  //   // disabled:true
  // },
  // {
  //   title: 'สรุปประเมินทดลองงาน',
  //   path: '/dashboardProbationEva',
  //   icon: icon('ic_sumProEva'),
  //   // disabled:true
  // },
  // {
  //   title: 'ประเมินประจำปี',
  //   path: '/probationEvaYear',
  //   icon: icon('ic_proEvaYear'),
  //   // disabled:true
  // },
  // {
  //   title: 'สรุปประเมินประจำปี',
  //   path: '/dashboardProbationEvaYear',
  //   icon: icon('ic_sumProEva'),
  //   // disabled:true
  // },
  // {
  //   title: 'แจ้งความประสงค์ลาออก',
  //   path: '/resignation',
  //   icon: icon('ic_resignation'),
  //   // disabled:true
  // },
  // {
  //   title: 'รายการพนักงานแจ้งลาออก',
  //   path: '/resignationList',
  //   icon: icon('ic_resignationList'),
  //   // disabled:true
  // },
  // {
  //   title: 'ระบบร้องเรียน',
  //   path: '/report',
  //   icon: icon('ic_report'),
  //   // disabled:true
  // },
 
];

export default navConfig;
